import { ComponentProps } from "react";
import { Route } from "react-router-dom";

export const RestrictedRoute = ({
  component,
  ...props
}: ComponentProps<typeof Route>) => {
  return <Route {...props} component={component} />;
};
